import SidebarState from "../../data/SidebarState";
import SideBarInfo from "./SideBarInfo";
import { ConstructionOutlined } from "@mui/icons-material";
import { PolylineOutlined } from '@mui/icons-material';
import { SettingsOutlined } from '@mui/icons-material';
import { InfoOutlined } from '@mui/icons-material';
import { useState, useRef, useEffect } from "react";
import StandardDropdown from "../widget/StandardDropdown"
import SplitPane from "react-split-pane";
import expand_arrow_up from "../../assets/images/expand_arrow_up.svg"
import expand_arrow from "../../assets/images/expand_arrow.svg"
import neighbour from "../../assets/images/arrow_back.svg"
import link from "../../assets/images/link.svg"
import link_external from "../../assets/images/external_link.svg"
import link_internal from "../../assets/images/internal_link.svg"
import expand_subtree from "../../assets/images/expand_subtree.svg"
import expand_subtree_ref from "../../assets/images/expand_subtree_ref.svg"

import hide from "../../assets/images/hide.svg"

const key_width = "150px"

const WindowContent = ({ icon, title, content, className="" }) => {
    return (
        <div className={`flex-column ${className}`} style={{gap: "25px"}}>
            <div className="flex-row centered-vertical" style={{gap: "13px"}}>
                {icon}
                <h2 className="light no-margin">{title}</h2>
            </div>
            {content}
        </div>
    );
}

const InfoContent = ({graphName, treeCount, nodeCount}) => {
    const content = (
    <div className="flex-column" style={{gap: "8px"}}>
        <SideBarInfo info_key="Graph" value={graphName} key_width={key_width}/>
        <SideBarInfo info_key="Number of nodes" value={nodeCount} key_width={key_width}/>
        <SideBarInfo info_key="Number of trees" value={treeCount} key_width={key_width}/>
    </div>
    );

    return (
        <WindowContent 
        icon={<InfoOutlined sx={{ color: "white" }}/>}
        title="Info"
        content={content}
        />
    );
}

const ConfigureContent = ({graphName, api_switch_graph, graphNames}) => {
    const [dropdownGraphName, setDropdownGraphName] = useState(graphName);

    const handleDropdownGraphName = (event) => {
        setDropdownGraphName(event.target.id)
      }

    const content = (
    <div className="flex-column" style={{gap: "8px", width: "290px"}}>
         <span className="font-medium semibold light">Graph</span>
        <StandardDropdown id="dropdown_label" text={graphName} options={graphNames} white={true} onClick={handleDropdownGraphName} default_selected={graphName}/>
        <div role="button" className="standard-button" onClick={() => api_switch_graph(dropdownGraphName)}>
            <span className="font-large light centered" >Update</span>
        </div>
    </div>
    );

    return (
        <WindowContent 
        icon={<SettingsOutlined sx={{ color: "white" }}/>}
        title="Configure"
        content={content}
        />
    );
}

const BuilderContent = ({trees, api_get_tree}) => {
    const [dropdownTree, setDropdownTree] = useState(null);

    const handleDropdownTree = (event) => {
        setDropdownTree(event.target.id)
      }

    const content = (
    <div className="flex-column" style={{gap: "8px", width: "290px"}}>
         <span className="font-medium semibold light">Display a tree</span>
        <StandardDropdown id="dropdown_label" text={"Select a tree"} options={trees} scrollable={true} white={true} onClick={handleDropdownTree}/>
        <div role="button" className="standard-button" onClick={() => api_get_tree(dropdownTree)}>
            <span className="font-large light centered" >Show</span>
        </div>
    </div>
    );
    return (
        <WindowContent 
        icon={<ConstructionOutlined sx={{ color: "white" }}/>}
        title="Builder"
        content={content}
        />
    );
}

const NodeInfoContent = ({nodeInfo, get_connected_nodes, hide_subtree, nodeIsParanted, sidebarWidth}) => {
    const [resetTrigger, setResetTrigger] = useState(0); // Used to trigger resets
    useEffect(() => {
        setResetTrigger(prev => prev + 1); // Increment to trigger resets
    }, [nodeInfo]);
    
    if (!nodeInfo) {
        return (
            <div className='flex-column nodeInfoPane'>
                <div>No data available</div>
            </div>
        );
    }

    const InfoElement = ({title, content, isExpandable = false, resetTrigger=null }) => {
        const [expanded, setExpanded] = useState(false);
        const toggleExpanded = () => setExpanded(!expanded);
        const isLongText = isExpandable && content.length > 400;

        useEffect(() => {
            setExpanded(false);
        }, [resetTrigger]);
        

        if (content === null || content === "") {
            content = "No data available"
        }
        return (
            <div className='flex-column nodePaneInfoElement'>
                <div style={{wordBreak: "break-word"}}><strong>{title}</strong></div>
                
                <div style={{wordBreak: "break-word"}}>
                {isLongText && !expanded ? (
                    <>
                        {content.slice(0, 400)}...
                        <br />
                        <a href="#" onClick={(e) => { e.preventDefault(); toggleExpanded(); }} 
                            style={{ color: "#008A8B", cursor: "pointer" }}>
                            more
                        </a>
                    </>
                ) : (
                    <>
                        {content}
                        {isLongText && (
                            <>
                                <br />
                                <a href="#" onClick={(e) => { e.preventDefault(); toggleExpanded(); }} 
                                    style={{ color: "#008A8B", cursor: "pointer" }}>
                                    hide
                                </a>
                            </>
                        )}
                    </>
                )}
                </div>
            </div>
        );
    }

    console.log(nodeInfo)

    //TODO: Få knappene til å funke
    //Fjern external referneces

     // Runs when content changes (new popup opens)

    const content = (
        <div className='flex-column nodeInfoPane'>
        <InfoElement title="Name:" content={nodeInfo.name} />
        <InfoElement title="Partition ID:" content={nodeInfo.partition_id} />
        <InfoElement title="Partition Text:" content={nodeInfo.part_text} />
        <InfoElement title="Document ID:" content={nodeInfo.doc_id} />
        <InfoElement title="Document Text:" content={nodeInfo.doc_text} isExpandable={true} resetTrigger={resetTrigger} />
        </div>    
   )
   /*
   <div className={`nodeinfo-button-panel ${ sidebarWidth < 400 ? "small" : ""}`}>
        
        
        {nodeInfoButton("Hide subtree", hide, () => hideSubtree(nodeInfo.data.id), "hide")}
    </div>
   */

    return (
        <WindowContent 
        icon={<InfoOutlined sx={{ color: "white" }}/>}
        title={nodeInfo.title}
        content={content}
        className="node-info-height"
        />
    );
    }


const SidebarWindow = ({ sidebarState, graphName, treeCount, nodeInfo, nodeCount, api_switch_graph, graphNames, trees, api_get_tree, get_connected_nodes, hide_subtree, nodeIsParanted }) => {
    const [sidebarWidth, setSidebarWidth] = useState(350); // Initial sidebar width
    const sidebarRef = useRef(null);

    // Function to handle resizing
    const handleMouseDown = (event) => {
        event.preventDefault();
        
        const startX = event.clientX;
        const startWidth = sidebarRef.current.offsetWidth;
        
        const handleMouseMove = (moveEvent) => {
            const newWidth = startWidth + (moveEvent.clientX - startX);
            setSidebarWidth(Math.max(350, Math.min(newWidth, window.innerWidth * 0.8))); // Restrict between 200px and 600px
        };

        const handleMouseUp = () => {
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
        };

        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
    };

    useEffect(() => {
        if (sidebarState !== SidebarState.NODEINFO) {
            setSidebarWidth(350)
        }
    }, [sidebarState])

    const nodeInfoButton = (title, icon, onClick, className="") => {
        return (
        <div role="button" className={`flex-row nodeInfoButton ${className}`} style={{gap: "8px"}} onClick={onClick}>
            <div className="flex-column">
            <img style={{width: "24px"}} src={icon}/>
            </div>
        </div>
        )
    }

    const showChildren = (nodeId) => {
        get_connected_nodes(nodeId, "child")
    };    

    const showNeighbours = (nodeId, reference="ref") => {
        get_connected_nodes(nodeId, reference)
    };

    const showParent = (nodeId) => {
        get_connected_nodes(nodeId, "parent")
    }

    const showSubtree = (nodeId) => {
        get_connected_nodes(nodeId, "subtree")
    }

    const showSubtreeRef = (nodeId) => {
        get_connected_nodes(nodeId, "subtree_ref")
    }

    const hideSubtree = (nodeId) => {
        console.log(typeof nodeId)
        hide_subtree(nodeId.toString());
    };

    const toolbar_max_width = 600
    const toolbar_break_width = 420
    const is_toolbar_break = sidebarWidth < toolbar_break_width
    let toolbar_inner = ""
    if (nodeInfo !== null) {
        toolbar_inner = (
            <div className={`nodeinfo-button-container ${is_toolbar_break ? "long" : ""}`} style={{gap: sidebarWidth < toolbar_max_width ? `4px` : "14px"}}>
                {!nodeIsParanted(nodeInfo.data) ? nodeInfoButton("Expand up", expand_arrow_up, () => showParent(nodeInfo.data.id), "expand_up") : ""}
                {!nodeInfo.data.isLeaf ? nodeInfoButton("Expand down", expand_arrow, () => showChildren(nodeInfo.data.id), "expand_down") : ""}
                {nodeInfo.data.hasExternalNeighbour ? nodeInfoButton("Show external references", link_external, () => showNeighbours(nodeInfo.data.id, "external_ref"), "external") : ""}
                {nodeInfo.data.hasInternalNeighbour ? nodeInfoButton("Show internal references", link_internal, () => showNeighbours(nodeInfo.data.id, "internal_ref"), "internal") : ""}
                {!nodeInfo.data.isLeaf ? nodeInfoButton("Show subtree", expand_subtree, () => showSubtree(nodeInfo.data.id), "expand_subtree") : ""}
                {!nodeInfo.data.isLeaf ? nodeInfoButton("Show subtree and references", expand_subtree_ref, () => showSubtreeRef(nodeInfo.data.id), "expand_subtree_ref") : ""}
                {nodeInfoButton("Hide subtree", hide, () => hideSubtree(nodeInfo.data.id), "hide")}
            </div>
    );
    } 

    


    const toolbar = (
        <div className="flex-column node-toolbar">
            {sidebarWidth < toolbar_max_width ? toolbar_inner : <div style={{display: "flex" ,justifyContent: "center"}}>{toolbar_inner}</div>}
        </div>
       )
   

    return (
        <div className="sidebar-container">
            {/* Sidebar */}
            <div className="flex-column">
            <div 
                ref={sidebarRef}
                className={`sidebar-window ${sidebarState === SidebarState.HIDDEN ? "hidden" : ""} ${sidebarState === SidebarState.NODEINFO ? `${is_toolbar_break ? "nodeinfo-short" : "nodeinfo-long"}` : ""}`}
                style={{ width: `${sidebarWidth}px`}}
            >
                {sidebarState === SidebarState.INFO && (
                    <InfoContent graphName={graphName} treeCount={treeCount} nodeCount={nodeCount} />
                )}
                {sidebarState === SidebarState.CONFIGURE && (
                    <ConfigureContent graphName={graphName} api_switch_graph={api_switch_graph} graphNames={graphNames} />
                )}
                {sidebarState === SidebarState.BUILDER && (
                    <BuilderContent trees={trees} api_get_tree={api_get_tree} />
                )}
                {sidebarState === SidebarState.NODEINFO && (
                    <NodeInfoContent 
                    nodeInfo={nodeInfo} 
                    get_connected_nodes={get_connected_nodes}
                    hide_subtree={hide_subtree}
                    nodeIsParanted={nodeIsParanted}
                    sidebarWidth={sidebarWidth}
                    />
                )}
            </div>
            {sidebarState === SidebarState.NODEINFO ? 
            <div className={`toolbar-container ${is_toolbar_break ? "long" : "short"}`}>{toolbar}</div>
            : ""}
            </div>

            {/* Resizer */}
            {sidebarState === SidebarState.NODEINFO && (

            <div className="resizer" onMouseDown={handleMouseDown}></div>
            )}
            </div>
    );
};

export default SidebarWindow;